export default __webpack_public_path__ + "static/media/spin3.5c22c882.gif";